<template><div><h1 id="alte-artikelnummern" tabindex="-1"><a class="header-anchor" href="#alte-artikelnummern"><span>Alte Artikelnummern</span></a></h1>
<p>Alte Artikelnummern — Steuerung der Auftragserfassung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>&gt;Diese Tabelle hat Auswirkungen auf die Auftragserfassung: Man kann z.B. steuern, dass bei der Auftragserfassung eine alte, nicht mehr gültige Artikelnummer durch eine aktuelle ersetzt wird. Das funktioniert auch bei Änderung der Auftragsposition. Der Benutzer erhält eine Bildschirmmeldung: &quot;Artikelnummer 'ArtNum ALT' wurde durch 'ArtNum NEU' ersetzt.</p>
<p>Pfad: <code v-pre>Logistik → Tabellen → Alte Artikelnummern</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Alte Nummer</dt>
<dd>alte Artikelnummer, 7-stellig, alphanumerisch. Achtung: die Nummer wird bei der Eingabe nicht validiert!</dd>
<dt>ArtNum</dt>
<dd>Artikelnummer, die anstelle der alten Artikelnummer eingegeben werden soll; sie wird vom System mit dem aktuellen Artikelstamm validiert</dd>
<dt>Kommentar</dt>
<dd>Kommentar, Bezeichnung der Zuordnung, welcher in der Hinweismeldung erscheint</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/artikel_und_lagerverwaltung.html" title="3. Artikel- und Lagerverwaltung">Lagerverwaltung</RouteLink></p>
</div></template>


